// Tiny shared primitives for the pipeline builder. App-token styling only.
// cn comes from the shared client helper; Button/Mono stay local because they
// carry the builder's compact chip styling. (Follow-up: fold into FbUI.)
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from 'components/UI/cn'

export { cn }

interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary'
}

export function Button({
  variant = 'default',
  className,
  children,
  ...rest
}: BtnProps) {
  return (
    <button
      type="button"
      className={cn(
        'rounded-md border px-2.5 py-1 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40',
        variant === 'primary'
          ? 'border-brand bg-brand text-fg-inverse hover:bg-brand-hover'
          : 'border-line bg-surface text-fg hover:border-brand hover:text-brand',
        className
      )}
      {...rest}
    >
      {children}
    </button>
  )
}

/** A monospace code-ish chip used throughout (op steps, dest paths, badges). */
export function Mono({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <span className={cn('font-mono', className)}>{children}</span>
}
